import type { DatasetsMutatorDeleteDatasetProps } from "./datasets-mutator-delete-dataset.type";

import { useDelete } from "@/hooks/queries";

import { useDatasetsMutatorHandleMutate } from "../datasets-mutator.hook";

export const useDatasetsMutatorDeleteDataset = ({
  mutatorItem,
  onDatasetDelete,
  invalidateKeys,
}: DatasetsMutatorDeleteDatasetProps) => {
  const { datasetId } = mutatorItem;

  const { mutate, status } = useDelete("datasets", datasetId, {
    invalidateKeys,
    onSuccess: onDatasetDelete,
  });

  const deleteDataset = () => {
    mutate(null);
  };

  useDatasetsMutatorHandleMutate({
    mutatorItems: [mutatorItem],
    mutationStatus: status,
    onMutateReady: () => deleteDataset(),
  });

  return null;
};
